/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_CreateInputs */

const cs_settings_users_create = /** @type {(inputs: Settings_Users_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit uživatele`)
};

const en_settings_users_create = /** @type {(inputs: Settings_Users_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create user`)
};

/**
* | output |
* | --- |
* | "Create user" |
*
* @param {Settings_Users_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_create = /** @type {((inputs?: Settings_Users_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_create(inputs)
	return cs_settings_users_create(inputs)
});